import { Box, Typography, Container } from '@mui/material';
const CommonPage = ({ title, children }) => {
  return (
    <Container maxWidth="lg" sx={{ 
      py: 4, 
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box sx={{ 
        textAlign: 'center', 
        mb: 4,
        flex: 1
      }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {children || 'এই পেজটি শীঘ্রই আপডেট করা হবে। ধৈর্য্য ধারণ করার জন্য ধন্যবাদ।'}
        </Typography>
      </Box>
    </Container>
  );
};
export default CommonPage;
